import { Link } from 'gatsby';
const PageLink = ({
  slug,
  activeClassName,
  partiallyActive,
  handleClick,
  tagCategory,
  tagAction,
  tagLabel,
  forwardSx,
  children,
}) => {
  const startsWithSlash = slug?.charAt(0) === '/';
  return (
    <Link
      to={slug ? (startsWithSlash ? `${slug}/` : `/${slug}/`) : '/'}
      aria-label={`Go to ${slug ?? 'homepage'}`}
      activeClassName={activeClassName}
      partiallyActive={partiallyActive}
      sx={{ ...forwardSx }}
      onClick={
        handleClick
          ? handleClick
          : (e) => {
              const event = new CustomEvent('custom-event', {
                bubbles: true,
                detail: { category: tagCategory, action: tagAction, label: tagLabel },
              });
              e.target.dispatchEvent(event);
            }
      }
    >
      {children}
    </Link>
  );
};

export default PageLink;
